// eslint-disable-next-line no-restricted-imports
import { useAsObservableSource } from 'mobx-react-lite';
import React, { useState } from 'react';
import { useAppStateContext } from 'src/AppState/AppState';
import { observer } from 'src/utils/mobx-react';
import { TimeEventSettingsState } from './TimeSettings.state';
import { DateTimeInput } from 'src/components/DateTimeInput/DateTimeInput';
import { DateTime } from 'src_common/utils/time/time';
import { EventId } from 'src_common/common/websocket2/id/WebsocketId';
import { BetDelayRow } from './TimeSettings.style';

interface TimeEventSettingsPropsType {
    eventId: EventId;
}

function upperFirstLetter(text: string): string {
    return text.substring(0, 1).toUpperCase() + text.substring(1);
}

export const TimeEventSettings = observer('TimeEventSettings', (propsIn: TimeEventSettingsPropsType) => {
    const props = useAsObservableSource(propsIn);
    const { sdkStaff } = useAppStateContext();
    const [timeEventSettingsState] = useState(() => new TimeEventSettingsState(() => props.eventId, sdkStaff));
    const {
        isLoadingEventUpdate,
        startTime,
        onChangeDate,
        onChangeTimeZone,
        timeline,
        onChangeTimeline,
        tradedInPlay,
        onChangeTradedInPlay,
        offAtStartTime,
        onChangeOffAtStartTime,
        autoTakeDown,
        onChangeAutoTakeDown,
        betDelay,
        onChangeBetDelay,
        onChangeBetDelaySave,
        TIMELINE_STATUS,
    } = timeEventSettingsState;

    const userTimeZone = DateTime.guessUserTimezone();

    return (
        <section className='event-details-box'>
            <h4>
                Time settings{' '}
                <span style={{ fontSize: '10px' }}>{isLoadingEventUpdate ? 'Making changes, wait...' : null}</span>
            </h4>
            <div>
                <div className='row'>
                    <div className='col-6'>
                        <div className='element'>
                            {startTime === null ? null : (
                                <DateTimeInput
                                    value={startTime}
                                    dateFormat='yyyy-MM-dd'
                                    timeFormat='HH:mm:ss'
                                    onChange={onChangeDate}
                                />
                            )}
                        </div>
                    </div>
                    <div className='col-6'>
                        {
                            <div className='element hasLabel'>
                                <div
                                    className='select-wrapper'
                                    data-test='time-zone-dropdown'
                                >
                                    <select
                                        value={userTimeZone}
                                        onChange={onChangeTimeZone}
                                    >
                                        <option
                                            disabled
                                            defaultValue={undefined}
                                        >
                                            {' '}
                                        </option>
                                        {/*{*/}
                                        {/*    AVAILABLE_TIMEZONES.map(tz => (*/}
                                        {/*        <option key={tz} value={tz}>{tz}</option>*/}
                                        {/*    ))*/}
                                        {/*}*/}
                                        <option
                                            key={userTimeZone}
                                            value={userTimeZone}
                                        >
                                            {userTimeZone}
                                        </option>
                                    </select>
                                    <label>Time zone</label>
                                </div>
                            </div>
                        }
                    </div>
                </div>
                <div className='row'>
                    <div className='col-6'>
                        <div className='element hasLabel'>
                            <div
                                className='select-wrapper'
                                data-test='event-status-dropdown'
                            >
                                <select
                                    value={timeline}
                                    onChange={onChangeTimeline}
                                >
                                    <option
                                        disabled
                                        defaultValue={undefined}
                                    >
                                        {' '}
                                    </option>
                                    {TIMELINE_STATUS.map((timeline) => (
                                        <option
                                            key={timeline}
                                            value={timeline}
                                        >
                                            {' '}
                                            {upperFirstLetter(timeline)}{' '}
                                        </option>
                                    ))}
                                </select>
                                <label>Event status</label>
                            </div>
                        </div>
                    </div>
                    <div className='col-6'>
                        <div
                            className='element checkbox'
                            data-test='traded-in-play-checkbox'
                        >
                            <label>
                                <input
                                    type='checkbox'
                                    checked={tradedInPlay}
                                    onChange={onChangeTradedInPlay}
                                />
                                <span>Traded In-play</span>
                            </label>
                        </div>
                    </div>
                </div>
                <div className='row'>
                    <div className='col-6'>
                        <div
                            className='element checkbox'
                            data-test='off-at-start-time-checkbox'
                        >
                            <label>
                                <input
                                    type='checkbox'
                                    checked={offAtStartTime}
                                    onChange={onChangeOffAtStartTime}
                                />
                                <span>Off at Start Time</span>
                            </label>
                        </div>
                    </div>
                    <div className='col-6'>
                        <div
                            className='element checkbox'
                            data-test='take-down-automatically-checkbox'
                        >
                            <label>
                                <input
                                    type='checkbox'
                                    checked={autoTakeDown}
                                    onChange={onChangeAutoTakeDown}
                                />
                                <span>Take down automatically</span>
                            </label>
                        </div>
                    </div>
                </div>
                <BetDelayRow>
                    <div className='col-6'>
                        <div className='element hasLabel'>
                            <input
                                value={betDelay}
                                type='number'
                                onChange={onChangeBetDelay}
                                onBlur={onChangeBetDelaySave}
                            />
                            <label>All Markets Bet Delay (in seconds)</label>
                        </div>
                    </div>
                </BetDelayRow>
            </div>
        </section>
    );
});
